export default import.meta.glob("./*.json", { import: "default" });
